import SingleWirePage from "components/pages/SingleWirePage";

/**
 * @name CaptureSinglePaymentDefault
 * @returns {React.Component}
 * @description 
 */
export default function CaptureSinglePaymentDefault(props) {
    return <SingleWirePage />;
}